webpackJsonp([14],{

/***/ 1898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _layoutEngine = __webpack_require__(1899);

var _layoutEngine2 = _interopRequireDefault(_layoutEngine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_layoutEngine2.default.vendor === 'ie' && _layoutEngine2.default.version <= 10) {
  __webpack_require__(1900);
}

/***/ }),

/***/ 1899:
/***/ (function(module, exports) {

module.exports = layoutEngine;

/***/ }),

/***/ 1900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(671);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).on('click', '.vjs-fullscreen-control', function () {
  toggleOverlayElements();
});

(0, _jquery2.default)(document).on('keydown', function (e) {
  if ([13, 27, 32].indexOf(e.which) === -1 || (0, _jquery2.default)('.vjs-has-started').hasClass('vjs-fullscreen')) {
    return;
  }

  setTimeout(toggleOverlayElements);
});

function toggleOverlayElements() {
  var overlayTiles = (0, _jquery2.default)('.vjs-fullscreen-control').closest('.overlay-tile').siblings().find('.overlay-tile');

  var closeButton = (0, _jquery2.default)('.close-overlay');

  if ((0, _jquery2.default)('.vjs-has-started').hasClass('vjs-fullscreen')) {
    overlayTiles.hide();
    closeButton.hide();
  } else {
    overlayTiles.show();
    closeButton.show();
  }
}

/***/ })

},[1898]);


// WEBPACK FOOTER //
// ie-bundle.53f71cba659bc9973aae.js